import { Box } from '@chakra-ui/react'

interface OpacityOverlayProps {
  isOpen: boolean
}
export const OpacityOverlay = ({ isOpen }: OpacityOverlayProps) => {
  return (
    <Box
      position='fixed'
      top={0}
      left={0}
      width='100vw'
      height='100vh'
      background='rgba(0, 0, 0, 0.5)'
      zIndex={99}
      display={isOpen ? 'block' : 'none'}
    ></Box>
  )
}
